import { LegacyRef, forwardRef } from 'react';
import CurrencyIcon from '../../assets/Line.png';
import classNames from 'classnames';
import { Currency, CurrencySymbol } from '../../types/location';

interface CurrencyInputProps {
  id: string;
  label: string;
  currency: Currency;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  value?: number;
  name: string;
}

const CurrencyInput = forwardRef(
  (props: CurrencyInputProps, ref: LegacyRef<HTMLInputElement>) => {
    const { id, label, description, error, currency } = props;

    return (
      <div
        className={classNames(
          `xpl-input w-full flex flex-col font-sans text-left font-normal leading-normal text-base mb-5`,
          { '!mb-[2px]': error },
        )}
      >
        <label
          htmlFor={id}
          className='leading-normal font-medium text-base text-black'
        >
          {label}
        </label>
        {!!description && (
          <p className='text-xs font-normal leading-4 text-gray-500'>
            {description}
          </p>
        )}
        <div className='xpl-input-wrapper flex-1 items-center gap-2 self-stretch border border-gray-300 rounded-md bg-white w-full pr-3 mt-1'>
          <span className='text-center text-darkmode-Text-Primary font-medium line-0'>
            {CurrencySymbol[currency]}
          </span>
          <input
            ref={ref}
            type='number'
            min={0}
            step='0.01'
            className='flex-1 ml-1 appearance-none focus:outline-none focus:ring-0 !text-gray-600'
            {...props}
            data-test-id={id}
          />
          <div className='ml-2'>
            <img src={CurrencyIcon} alt='Arrow' />
          </div>
          <span className='font-normal text-sm leading-6 text-right text-gray-500'>
            {currency}
          </span>
        </div>
        {error && <p className='text-xs leading-5 text-red-500'>{error}</p>}
      </div>
    );
  },
);

export default CurrencyInput;
